import { render, staticRenderFns } from "./sort-column-field.vue?vue&type=template&id=53f7a4de&"
import script from "./sort-column-field.vue?vue&type=script&lang=js&"
export * from "./sort-column-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports